import * as mqtt from 'mqtt/dist/mqtt.min';
import Cookie from '@/utils/cookie';
import { baseUrl, subscribeMessageApi, publishMessageApi } from '@/api/mqtt';

export default {
  data() {
    return {
      mqttEvent: {
        connected: false,
      },
      timer: '',
    };
  },
  methods: {
    mqttConnect1() {
      let username = Cookie.getCookie('name') || Cookie.getCookie('username') || Cookie.getCookie('phone');
      console.log('username', username);
      const params = { username, password: '123456' };
      this.client = mqtt.connect(baseUrl, params);
      this.client.on('connect', (event) => {
        console.log('connect成功');
        this.mqttEvent.connected = true;
        console.log(event);
        this.mqttSubscribe();
        this.mqttMessage();
        // 心跳包开启
        this.timer = setInterval(this.mqttMessage, 50000);
      });
      this.client.on('reconnect', (event) => {
        console.log('reconnect重连');
        console.log(event);
      });
      this.client.on('message', (topic, message) => {
        console.log('message 收到信息');
        console.log(new String(message).toString());
        let list = this.$store.state.rescue.rescueList.slice();
        let data = JSON.parse(new String(message).toString());
        if (data.monitorType && data.monitorType == 1) {
          list.push(data);
          this.$store.dispatch('rescue/fetch_rescueList', list);
        }
      });
      this.client.on('error', (error) => {
        console.log('error失败');
        console.log(error);
      });
    },
    mqttMessage() {
      if (this.mqttEvent.connected === true) {
        const payload = JSON.stringify({ message: 'CFMOTO RISK ' + this.$moment().format('YYYY-MM-DD HH:mm:ss') });
        this.client.publish(publishMessageApi, payload, { qos: 0 }, (error) => {
          if (error) {
            console.log('Publish error', error);
            return;
          }
          console.log(`published message: ${payload}`);
        });
      }
    },
    mqttSubscribe() {
      if (this.mqttEvent.connected === true) {
        this.client.subscribe(subscribeMessageApi, { qos: 0 }, (error, res) => {
          if (error) {
            console.log('Subscribe to topics error', error);
            return;
          }
          console.log('Subscribe to topics res');
          console.log(res);
        });
      }
    },
  },
  mounted() {
    const { userAuthorities } = this.$store.state;
    console.log('菜单');
    console.log('--console.vehicleMonitor.acciden');
    if (!userAuthorities.some((item) => item.action === 'console.vehicleMonitor.accident')) {
      return;
    }
    console.log('进行链接');
    this.mqttConnect1();
  },
  beforeUnmount() {
    this.client.end(false, () => {
      console.log('Successfully disconnected!');
    });
    clearInterval(this.timer);
    this.timer = null;
  },
};
